// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"586b027672c43b600d48","453":"c31c23179df4bbd4b97a","725":"8bcfe5d43c702bc0f763"}[chunkId] + ".js";
};